export const UNINITIALIZED = Symbol('uninitialized');
